<template>
<div class="chapter">
<div class="inner_page">
<div class="dedication" id="ded">
<p class="center"><span class="brown">For Danny, who is my loyal, indispensible partner in everything, including the creation of this book.</span></p>
<p class="center"><span class="brown">For Lucy, who is all joy.</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ded.vue?5953212c